<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3.75"
      y="2.0293"
      width="17.4475"
      height="2.31008"
      rx="1.15504"
      transform="rotate(45 3.75 2.0293)"
      fill="currentColor"
    />
    <rect
      x="16.042"
      y="3.6333"
      width="17.4493"
      height="2.31008"
      rx="1.15504"
      transform="rotate(135 16.042 3.6333)"
      fill="currentColor"
    />
  </svg>
</template>

<script>
  export default {
    name: 'CrossIcon2',
  };
</script>
